import {
    ResponsiveContainer,
    BarChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar
} from 'recharts';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { t } from 'i18next';

export default function WeeklyProgressChart({ weeklyStats, patientName }) {
    return (
        <Card>
            <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    {t('exerciseStats.weeklyEvolution')}
                    {patientName && (
                        <Typography
                            component="span"
                            variant="subtitle1"
                            color="text.secondary"
                            fontWeight={700}
                        >
                            {` – ${patientName}`}
                        </Typography>
                    )}
                </Typography>
                <Box
                    sx={{
                        height: 3,
                        width: 222,
                        backgroundColor: '#1976d2',
                        borderRadius: 2,
                        mb: 2
                    }}
                />
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={weeklyStats}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="week" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar
                            dataKey="done"
                            stackId="a"
                            fill="#1976d2"
                            name={t('exerciseStats.completed')}
                        />
                        <Bar
                            dataKey="skipped"
                            stackId="a"
                            fill="#7fb4e8"
                            name={t('exerciseStats.skipped')}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
}
